module.exports = __webpack_public_path__ + "media/images/Clock-outline-0c6f60eb.svg";